export default __webpack_public_path__ + "img/c1396e9f9ff6cb5dca2ab3da831ffe56.svg";